import { Injectable } from '@angular/core';
import { Buffer } from 'buffer';
import { format } from 'date-fns';
import { v4 as uuidv4 } from 'uuid';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root',
})
export class ApiHeadersService {
  private publicTraceId: string;
  private secureTraceId: string;

  constructor() {
    this.setCignaTraceId();
  }

  /**
   * Generates custom headers for API requests
   * Note: This generates a new service reference ID and timestamp each time it's called
   */
  generateApiHeaders() {
    this.setCignaTraceId();
    return {
      'x-cigna-public-trace-id': this.publicTraceId,
      'x-cigna-secure-trace-id': this.secureTraceId,
    };
  }

  private getOrCreatePublicTraceId(): string {
    const storedId = sessionStorage.getItem('cigna-public-trace-id');
    if (storedId) {
      return storedId;
    }
    const newId = uuidv4();
    sessionStorage.setItem('cigna-public-trace-id', newId);
    return newId;
  }

  private getOrCreateSecureTraceId(): string {
    const storedId = localStorage.getItem('cigna-secure-trace-id');
    if (storedId) {
      return storedId;
    }
    const newId = uuidv4();
    localStorage.setItem('cigna-secure-trace-id', newId);
    return newId;
  }

  setCignaTraceId(): void {
    if (window.location.href.includes('public')) {
      this.publicTraceId = this.getOrCreatePublicTraceId();
    } else {
      this.secureTraceId = this.getOrCreateSecureTraceId();
    }
  }
}
